import request from '@/utils/request'
import environment from '@/utils/environment'

export function userLogin(data) {
  return request({
    url: '/admin/setting/webUser/login',
    method: 'post',
    data
  })
}

export function getUserById() {
  return request({
    url: '/admin/setting/webUser/getByUserId',
    method: 'post'
  })
}
export function logout() {
  return request({
    url: '/admin/setting/out',
    method: 'post'
  })
}

export function captcha() {
  return request({
    url: '/admin/setting/webUser/getCode',
    method: 'get'
  })
}

// 微信用户管理
export function wxUserManagerList(data) {
  return request({
    url: '/admin/operate/appUser/list',
    method: 'post',
    data
  })
}
// 编辑微信用户信息
export function updateWxUser(data) {
  return request({
    url: '/appUser/personal',
    method: 'post',
    data
  })
}

// 解绑会员
export function unbindVip(data) {
  return request({
    url: '/appUser/unbindVip',
    method: 'post',
    data
  })
}
